import { render } from "./UsersListAddModal.vue?vue&type=template&id=b8b5bb34"
import script from "./UsersListAddModal.vue?vue&type=script&lang=js"
export * from "./UsersListAddModal.vue?vue&type=script&lang=js"

import exportComponent from "/data/api/peitho-pre.uniqoderslab.com/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__